import 'react-app-polyfill/ie9';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import store from './store/configureStore';
import Root from './containers/Root';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

unregisterServiceWorker();
